import React from 'react';

const CustomRadioArrowRight = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.33203 8H12.6654'
        stroke='#41415A'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 3.33334L12.6667 8.00001L8 12.6667'
        stroke='#41415A'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CustomRadioArrowRight;
